import { useEffect } from 'react';
import styled from '@emotion/styled';
import { useAtomValue, useSetAtom } from 'jotai/react';
import { useTranslation } from 'next-i18next';
import { LoginModalProps } from 'src/components/LoginModal';
import ModalLayoutBase, { MobileModalType } from 'src/components/ModalLayout';
import { ModalLoading } from 'src/components/ProductNudgingModal/styles';
import useLogin from 'src/hooks/useLogin';
import { isLoginLoadingAtom } from 'src/stores/auth/atoms';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { ModalType } from 'src/types/Modal';
import { pushEvent } from 'src/utils/event-gateway';
import LoginEntry from './LoginEntry';
const ModalLayout = styled(ModalLayoutBase)`
  max-width: 400px;

  ${({
  theme
}) => theme.screenSize.desktop} {
    padding: 16px;
  }
`;
const VividiLoginModal = ({
  loginSuccessCallback,
  trigger,
  ...modalLayoutProps
}: LoginModalProps) => {
  const {
    i18n: {
      language
    }
  } = useTranslation();
  const {
    isLogin
  } = useLogin();
  const isLoginLoading = useAtomValue(isLoginLoadingAtom);
  const closeModal = useSetAtom(closeModalAtom);
  useEffect(() => {
    if (isLogin) {
      if (loginSuccessCallback) {
        loginSuccessCallback();
      }
      closeModal(ModalType.LOGIN);
    }
  }, [isLogin, loginSuccessCallback, closeModal]);
  useEffect(() => {
    if (language) {
      pushEvent({
        eventType: EVENT_TYPE.SIGN_UP,
        eventName: EVENT_NAME.SCREEN_OPEN__LOGIN,
        eventParams: {
          language,
          trigger
        }
      });
    }
  }, [language, trigger]);
  return <ModalLayout isDim data-testid='login-modal' mobileType={MobileModalType.BOTTOM_SHEET} mobileBreakpoint='tablet' closeWhenClickOutside={true} closeWithESC={true} {...modalLayoutProps} data-sentry-element="ModalLayout" data-sentry-component="VividiLoginModal" data-sentry-source-file="index.tsx">
      {isLoginLoading && <ModalLoading type='absolute' />}
      <LoginEntry data-sentry-element="LoginEntry" data-sentry-source-file="index.tsx" />
    </ModalLayout>;
};
export default VividiLoginModal;